
import { TabsContent } from "../../components/ui/tabs"
import DailyDeliveryReportForm from "./DailyDeliveryReportForm"
import DailyDeliveryPageLayout from "./DailyDeliveryReportLayout"
import DailyDeliveryReportList from "./DailyDeliveryReportList"
import DailyDeliverySearchData from "./DailyDeliverySearchData"
import ShippingListTable from "./ShippingListTable"
import ShippingPageLayout from "./ShippingPageLayout"

const ShippingListPage = () => {
  return (
    <>
      <div className="">
        <DailyDeliveryPageLayout>
          <TabsContent value="todayData">
            <DailyDeliveryReportList />
          </TabsContent>
          <TabsContent value="searchData">
            <DailyDeliverySearchData />
          </TabsContent>
          <TabsContent value="createData">
            <DailyDeliveryReportForm />
          </TabsContent>
        </DailyDeliveryPageLayout>
      </div>
    </>
  )
}

export default ShippingListPage